import { useQuery } from "@tanstack/react-query";
import { queryUrl } from "../queryFunctions";

const useQueryUrl = (url) => {
  return useQuery([url], () => queryUrl(url), { cacheTime: 600000 });
};

export default useQueryUrl;
